export default __webpack_public_path__ + "static/media/bolanle.c685b84c.png";